import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { NotifierV2Service } from './notifier-v2.service';

/**
 * Functional route resolver that handles history updates based on route params.
 */
export const routeResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): any => {
  const notifierV2Service = inject(NotifierV2Service);

  if (route.params.data) {
    const dataObj = JSON.parse(route.params.data);
    if (dataObj.isUpdateHistory) {
      notifierV2Service.addToHistory(dataObj);
    }
    return dataObj;
  }
  return {};
};
